import { render } from "./notifications.vue?vue&type=template&id=2a7fac38&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=2a7fac38&scoped=true&lang=css&external"
import "./notifications.vue?vue&type=style&index=1&id=2a7fac38&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7fac38"]])

export default __exports__